'use client';
import {createStackNavigator} from '@react-navigation/stack';

import {Help} from '../screens/Help';
import {HelpArticle} from '../screens/Help/HelpArticle';
import {SubRegions} from '../screens/Localization/SubRegions';
import {Localization} from '../screens/Localization';
import {Products} from '../screens/Products';
import {Fuel} from '../screens/Fuel';
import {Product} from '../screens/Product';
import {ListagemPostos} from '../screens/Localization/ListagemPostos';
import {Station} from '../screens/Station';

import {AddCreditCard} from '../screens/CardsWallet/AddCreditCard';
import {EditCreditCardAddress} from '../screens/CardsWallet/EditCreditCardAdress';
import {UserCreditCardNotEligible} from '../screens/CardsWallet/UserCreditCardNotEligible';
import {AcceptCreditCardRegulament} from '../screens/CardsWallet/AcceptCreditCardRegulament';
import {ChangePassword} from '../screens/ChangePassword';
import {ConfirmationScreen} from '../screens/ConfirmationScreen';

import {User} from '../screens/User';
import {Account} from '../screens/User/Account';
import {DeleteAccount} from '../screens/User/Account/DeleteAccount';

//import {EmprestimoSimulacao} from '../screens/Emprestimo/Simulacao';
//import {EmprestimoPagamento} from '../screens/Emprestimo/Pagamento';

import {Payment} from '../screens/Payment';
import {Pix} from '../screens/Payment/Pix';

import {Discount} from '../screens/Payment/Discount';

import {Payment as PaymentNovo} from '../screens/Payment';
import {Pix as PixNovo} from '../screens/Payment/Pix';

import {Discount as DiscountNovo} from '../screens/Payment/Discount';


import {Coupon as CouponNovo} from '../screens/CouponNovo';

import {CouponStationsNovo} from '../screens/CouponNovo/CouponStations';
import {useLocalization} from '../context/localization';

import {PP_SearchDebits} from '../screens/ProntoPaguei/VehicleDebits/SearchDebits';
import {PP_Debits} from '../screens/ProntoPaguei/VehicleDebits/Debits';
import {PP_Checkout} from '../screens/ProntoPaguei/VehicleDebits/Checkout';
import {PP_TrackRequests} from '../screens/ProntoPaguei/VehicleDebits/TrackRequests';

import {Coupons} from '../screens/Coupons';
import {Reembolsos} from '../screens/Reembolsos';
import {DadosBancarios} from '../screens/Reembolsos/DadosBancários';
import {ConfirmaReembolso} from '../screens/Reembolsos/ConfirmaReembolso';
import {SolicitaReembolso} from '../screens/Reembolsos/SolicitaReembolso';
import {PedidosReembolso} from '../screens/Reembolsos/Pedidos';
import { Tutoriais } from '../screens/Tutoriais';
import { PaymentsHistory } from '../screens/User/PaymentsHistory';

const {Navigator, Screen} = createStackNavigator();

interface WebStackNavProps {
  debitoVeicular?: boolean;
}

export function WebStackNav({debitoVeicular}: WebStackNavProps) {
  const options = {
    headerShown: false,
    gestureEnabled: false,
  };

  const {position} = useLocalization();

  const initialRouteName = debitoVeicular
    ? 'PP_SearchDebits'
    : position?.latitude && position?.longitude
    ? 'ListagemPostos'
    : 'Localization';

  return (
    <Navigator screenOptions={options} initialRouteName={initialRouteName}>
      <Screen
        name="Localization"
        //@ts-ignore
        component={Localization}
        initialParams={{
          tipo: 'C',
        }}
      />

      <Screen name="Coupons" component={Coupons} />

      <Screen
        name="ListagemPostos"
        //@ts-ignore
        component={ListagemPostos}
        initialParams={{
          tipo: 'C',
        }}
      />

      {/* @ts-ignore */}
      <Screen name="SubRegions" component={SubRegions} />
      {/* @ts-ignore */}

      <Screen name="Products" component={Products} />
      <Screen name="Fuel" component={Fuel} />
      <Screen name="Product" component={Product} />
      <Screen name="Help" component={Help} />
      <Screen name="HelpArticle" component={HelpArticle} />
      <Screen name="Station" component={Station} />
      <Screen
        name="PaymentsHistory"
        component={PaymentsHistory}
        options={{gestureEnabled: true}}
      />
      {/**FLUXO PAGAMENTO ANTIGO (VALIDADO) */}
      <Screen
        name="Payment"
        component={Payment}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="Discount"
        component={Discount}
        options={{gestureEnabled: true}}
      />
      <Screen name="Pix" component={Pix} options={{gestureEnabled: false}} />

      {/**FLUXO PAGAMENTO NOVO (NAO VALIDADO) */}
      <Screen
        name="PaymentNovo"
        component={PaymentNovo}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="DiscountNovo"
        component={DiscountNovo}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="PixNovo"
        component={PixNovo}
        options={{gestureEnabled: false}}
      />

      <Screen
        name="AddCreditCard"
        component={AddCreditCard}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="EditCreditCardAddress"
        component={EditCreditCardAddress}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="UserCreditCardNotEligible"
        component={UserCreditCardNotEligible}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="AcceptCreditCardRegulament"
        component={AcceptCreditCardRegulament}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="ChangePassword"
        component={ChangePassword}
        options={{gestureEnabled: false}}
      />
      <Screen
        name="ConfirmationScreen"
        component={ConfirmationScreen}
        options={{gestureEnabled: false}}
      />
      <Screen
        //@ts-ignore
        name="User"
        component={User}
        options={{gestureEnabled: true}}
      />
      <Screen
        //@ts-ignore
        name="Account"
        component={Account}
        options={{gestureEnabled: true}}
      />
      <Screen
        //@ts-ignore
        name="DeleteAccount"
        component={DeleteAccount}
        options={{gestureEnabled: true}}
      />
     {/**<Screen
        name="EmprestimoSimulacao"
        component={EmprestimoSimulacao}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="EmprestimoPagamento"
        component={EmprestimoPagamento}
        options={{gestureEnabled: true}}
      />**/}


      <Screen
        name="CouponNovo"
        component={CouponNovo}
        options={{gestureEnabled: true}}
      />

      <Screen
        name="CouponStationsNovo"
        component={CouponStationsNovo}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="Reembolsos"
        //@ts-ignore
        component={Reembolsos}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="DadosBancarios"
        //@ts-ignore
        component={DadosBancarios}
        options={{gestureEnabled: true}}
      />
      <Screen
        //@ts-ignore
        name="ConfirmaReembolso"
        //@ts-ignore
        component={ConfirmaReembolso}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="SolicitaReembolso"
        //@ts-ignore
        component={SolicitaReembolso}
        options={{gestureEnabled: true}}
      />
      <Screen
        name="PedidosReembolso"
        //@ts-ignore
        component={PedidosReembolso}
        options={{gestureEnabled: true}}
      />

      {/**FLUXO DÉBITO VEICULAR */}
      {/* @ts-ignore */}
      <Screen
        name="PP_SearchDebits"
        component={PP_SearchDebits}
        options={{gestureEnabled: false}}
      />
      {/* @ts-ignore */}
      <Screen
        name="PP_Debits"
        component={PP_Debits}
        options={{gestureEnabled: false}}
      />
      {/* @ts-ignore */}
      <Screen
        name="PP_Checkout"
        component={PP_Checkout}
        options={{gestureEnabled: false}}
      />
      {/* @ts-ignore */}
      <Screen
        name="PP_TrackRequests"
        component={PP_TrackRequests}
        options={{gestureEnabled: false}}
      />

       <Screen
        name="Tutoriais"
        component={Tutoriais}
        options={{gestureEnabled: false}}
      />
    </Navigator>
  );
}
